<template>
  <v-content class="pa-0">
    <v-layout justify-center fluid fill-height>
      <v-flex text-center>
        <section id="news" class="pt-10 bg_color">
          <div class="section-heading">
            <h1 class="mb-10">ニュース</h1>
            <div class="animation">
              <div class="text-left news-tite">
                <a
                  href="https://s3-ap-northeast-1.amazonaws.com/prod-glc/pdf/20180925.pdf"
                  target="_blank"
                >「スマートミラー2045」阪急うめだ店での活用事例が『日経MJ新聞』に掲載されました</a>
              </div>
              <div class="news-date text-left">2018/09/25</div>
            </div>

            <div class="animation">
              <div class="text-left news-tite">
                <a
                  href="https://prtimes.jp/main/html/rd/p/000000030.000030247.html"
                  target="_blank"
                >「スマートミラー2045」ヘアサロン向けの販促等にて美的感覚集団 美髪堂株式会社と業務提携を開始</a>
              </div>
              <div class="news-date text-left">2018/09/20</div>
            </div>

            <div class="animation">
              <div class="text-left news-tite">
                <a
                  href="https://prtimes.jp/main/html/rd/p/000000028.000030247.html"
                  target="_blank"
                >「スマートミラー2045」を阪急うめだ本店バックギャラリーにてご採用いただきました</a>
              </div>
              <div class="news-date text-left">2018/09/04</div>
            </div>

            <div class="animation">
              <div class="text-left news-tite">
                <a
                  href="http://bae.dentsutec.co.jp/articles/ranking_1807/"
                  target="_blank"
                >「スマートミラー2045」が”電通テック”のメディア『BAE』に掲載されました</a>
              </div>
              <div class="news-date text-left">2018/04/03</div>
            </div>
          </div>
        </section>
      </v-flex>
    </v-layout>
  </v-content>
</template>

<script>

export default {
  name: 'News'
}
</script>

<style scoped>
ul {
  list-style-type: none;
  padding: 0;
}
a {
  color: #225086;
}
#news {
  margin-top: 64px;
  height: 100%;
}
#news.bg_color {
  background-color: #fff;
}
#news .section-heading {
  max-width: 1170px;
  margin: 0 auto;
  padding: 0 15px;
}
#news .section-heading p {
  font-size: 14px;
  font-weight: 300;
  color: #727272;
  line-height: 20px;
}
#news .section-heading .animation {
  visibility: visible;
  animation-delay: 0.5s;
  animation-name: fadeInDown;
  background-color: white;
}
#news .section-heading a {
  border-bottom: 1px dotted #8f8f8f;
  line-height: 25px;
}
#news .section-heading .news-tite {
  padding-bottom: 3px;
  margin-bottom: 10px;
  line-height: 20px;
}
#news .section-heading .news-date {
  font-size: 14px;
  font-weight: 300;
  color: #727272;
  line-height: 20px;
  margin-bottom: 10px;
}
</style>
